var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sprint-module"},[_c('div',{staticClass:"k-sprint",style:(_vm.aStyle)},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"btn-item",style:({
        width: _vm.$unit(item.btnWidth),
        left: _vm.$unit(item.btnLeft),
        bottom: _vm.$unit(item.btnBottom)
      }),on:{"click":function($event){return _vm.startTurns(index)}}},[_c('img',{staticClass:"btn",class:{ gray: _vm.btnStatus(index).style.gray },attrs:{"src":_vm.btnStatus(index).imgPath}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }